import { Fragment, useEffect, useState } from "react"
import { Col, Form } from "react-bootstrap";


const ZipCodeInput = (props) => {
    const [isValid, setIsValid] = useState(false);
    const [zipCodeValue, SetZipCodeValue] = useState('')

    const handleValueChange = (value, key) => {
        value = value.replace(/[^0-9]/g, '');
        SetZipCodeValue(value)

        if (value.length === 5) {
            setIsValid(false);
        }
        else if (props.showErrorMessage && value.length < 5) {
            setIsValid(true);
        }

        props.handleValueChange(value);
    }



    useEffect(() => {

        if (props?.showErrorMessage && zipCodeValue.length < 5) {
            setIsValid(true);
        }

        if (zipCodeValue.length === 5) {
            setIsValid(false);
        }

        if (zipCodeValue === '') { /*for updating the zip code without making any changes in zip code*/
            setIsValid(false);
        }
    }, [props.showErrorMessage])




    return (
        <Fragment>
            {
                <>
                    <fieldset className={`default-fieldset InputAutoHeight`}>
                        {props.label ? <legend className='default-fieldset-label'>{props.label}</legend> : null}
                        {/* <Form.Group className={props?.groupClassName} as={props.column ? Col : null} sm={props.sm ? props.sm : null} controlId={props?.controlId} > */}
                        {/* {props.label ? (<Form.Label className={props?.labelClassName}>Zip Code</Form.Label>) : null} */}
                        <Form.Control
                            required={props?.required}
                            type="text"
                            name={props.name ? props.name : "zip_code"}
                            placeholder={props.placeholder ? "Zip Code" : ""}
                            minLength={5}
                            maxLength={5}
                            className={props?.controlClassName}
                            value={props.data}
                            onChange={(e) => handleValueChange(e.target.value, 'zipCode')}
                            defaultValue={props.defaultValue ? props.defaultValue : null}
                            disabled={props?.disabled}
                            pattern="[0-9]{5}"
                        />
                        {/* </Form.Group> */}
                    </fieldset>
                    <Form.Control.Feedback type="invalid">
                        Please enter valid Zip Code.
                    </Form.Control.Feedback>
                </>
            }

        </Fragment>
    )
}


export default ZipCodeInput;